// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -640458706
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Hcpcs } from './models/common/hcpcs';

@Injectable({
  providedIn: 'root',
})
export class HcpcsApiService {
  constructor(protected http: HttpClient) {}

  getHcpcsByCode(hcpcsCode: string): Observable<Hcpcs> {
    const url = environment.chiliSauceApiRoot + `/api/Hcpcs/${hcpcsCode}`;
    return this.http.get<Hcpcs>(url);
  }
}
